import { Injectable, Inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { DiscoveryComponent } from './discovery/discovery.component';

@Injectable()
export class DiscoveryDeactivateGuard  {

	canDeactivate(target: DiscoveryComponent, currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot) {

		if (target) {
			let result = true;

			if (target.isSaveEnabled()) {
				// Try to continue navigation after user closes dialog.
				// However, if nextState is not provided, give up on 
				// continuing the navigation (but still open the dialog)

				let navUrl: string = null;
				if (nextState && nextState.url) {
					navUrl = nextState.url;
				}
				result = target.onSave(navUrl);
			}

			return result;
		}
		else {
			return false;
		}
	}

}
